
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/express-checkout/[projectSlug]",
      function () {
        return require("private-next-pages/[locale]/express-checkout/[projectSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/express-checkout/[projectSlug]"])
      });
    }
  